export default {
    isBetaSeller: state => state.isBetaSeller    
}